/*
Controller: UserManagement

Operations:
  addUserWithPermissionsToFoundry
  allFoundryUser
  deleteUserFromFoundry
  updateFoundriesUserPermissions
  getRoles
  searchUserByEmail
*/
var Api = require('../config')
var PermissionsDef = require('../definitions/Permissions')

var UserManagement = (function () {
  /*
  Operation: addUserWithPermissionsToFoundry
  Link a user with permissions to a foundry
  Parameters:
    foundryId: Id of foundry
    bodyRequest: permissionIds object
  Responses:
    HTTP 200: User with permissions Added successfully
    HTTP 412: Auth0 API Connection Issue
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function addUserWithPermissionsToFoundryUserManagement (foundryId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!foundryId) {
          throw new Error('foundryId: Missing parameter')
        }
        if (foundryId && !(typeof foundryId === 'string')) {
          throw new Error('foundryId: Wrong type: Got "' + (typeof foundryId) + '", but expected: "string"')
        }
        PermissionsDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/foundries/{foundryId}/linkUserToFoundry'
      path = path.replace('{' + 'foundryId' + '}', foundryId)
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: allFoundryUser
  Get all users for foundries along with permission
  Parameters:
    foundryId: Id of the foundry
  Responses:
    HTTP 200: user list for foundry
    HTTP 403: Operation not permitted
    HTTP 404: foundry user not found
  */
  function allFoundryUserUserManagement (foundryId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!foundryId) {
          throw new Error('foundryId: Missing parameter')
        }
        if (foundryId && !(typeof foundryId === 'string')) {
          throw new Error('foundryId: Wrong type: Got "' + (typeof foundryId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/foundries/{foundryId}/users'
      path = path.replace('{' + 'foundryId' + '}', foundryId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: deleteUserFromFoundry
  Unlink a user from a foundry
  Parameters:
    foundryId: Id of foundry
    userId: Id of user
  Responses:
    HTTP 200: OK
    HTTP 400: Failed to delete User
    HTTP 403: Operation not permitted
    HTTP 404: User not found
  */
  function deleteUserFromFoundryUserManagement (foundryId, userId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!foundryId) {
          throw new Error('foundryId: Missing parameter')
        }
        if (foundryId && !(typeof foundryId === 'string')) {
          throw new Error('foundryId: Wrong type: Got "' + (typeof foundryId) + '", but expected: "string"')
        }
        if (!userId) {
          throw new Error('userId: Missing parameter')
        }
        if (userId && !(typeof userId === 'string')) {
          throw new Error('userId: Wrong type: Got "' + (typeof userId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/foundries/{foundryId}/users/{userId}'
      path = path.replace('{' + 'foundryId' + '}', foundryId)
      path = path.replace('{' + 'userId' + '}', userId)
      Api
        .request({
          url: path,
          method: 'delete',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: updateFoundriesUserPermissions
  Update user&#39;s permissions of a foundry
  Parameters:
    foundryId: Id of foundry
    userId: Id of user
    bodyRequest: permissionIds object
  Responses:
    HTTP 200: Permissions updated successfully
    HTTP 412: Auth0 API Connection Issue
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function updateFoundriesUserPermissionsUserManagement (foundryId, userId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!foundryId) {
          throw new Error('foundryId: Missing parameter')
        }
        if (foundryId && !(typeof foundryId === 'string')) {
          throw new Error('foundryId: Wrong type: Got "' + (typeof foundryId) + '", but expected: "string"')
        }
        if (!userId) {
          throw new Error('userId: Missing parameter')
        }
        if (userId && !(typeof userId === 'string')) {
          throw new Error('userId: Wrong type: Got "' + (typeof userId) + '", but expected: "string"')
        }
        PermissionsDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/foundries/{foundryId}/users/{userId}'
      path = path.replace('{' + 'foundryId' + '}', foundryId)
      path = path.replace('{' + 'userId' + '}', userId)
      Api
        .request({
          url: path,
          method: 'put',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getRoles
  get roles from auth0
  Parameters:
  Responses:
    HTTP 200: Valid response
    HTTP 400: Invalid request URI.
    HTTP 403: Operation not permitted
  */
  function getRolesUserManagement () {
    return new Promise(function (resolve, reject) {
      try {
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var path = '/getRoles'
      Api
        .request({
          url: path,
          method: 'get'
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: searchUserByEmail
  Search user by email
  Parameters:
    email: Email of user
  Responses:
    HTTP 200: Valid response
    HTTP 412: Auth0 API Connection Issue
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function searchUserByEmailUserManagement (email) {
    return new Promise(function (resolve, reject) {
      try {
        if (!email) {
          throw new Error('email: Missing parameter')
        }
        if (email && !(typeof email === 'string')) {
          throw new Error('email: Wrong type: Got "' + (typeof email) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters['email'] = email
      var path = '/users/search'
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['addUserWithPermissionsToFoundry'] = addUserWithPermissionsToFoundryUserManagement
  ret['allFoundryUser'] = allFoundryUserUserManagement
  ret['deleteUserFromFoundry'] = deleteUserFromFoundryUserManagement
  ret['updateFoundriesUserPermissions'] = updateFoundriesUserPermissionsUserManagement
  ret['getRoles'] = getRolesUserManagement
  ret['searchUserByEmail'] = searchUserByEmailUserManagement
  return ret
})()

module.exports = UserManagement
